import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { CreateCompanyForm } from '@/components/companies/CreateCompanyForm'
import { Button } from '@/components/ui/button'

export default function CreateCompany() {
  const navigate = useNavigate()
  const [showForm, setShowForm] = useState(true)

  const handleSuccess = () => {
    setShowForm(false)
    // Navigate back to company management after short delay
    setTimeout(() => {
      navigate('/companies')
    }, 1500)
  }

  const handleCancel = () => {
    navigate('/companies')
  }

  return (
    <div className="min-h-screen bg-background py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-6">
          <Button
            variant="outline"
            onClick={() => navigate('/companies')}
            className="mb-4"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Companies
          </Button>
          <h1 className="text-3xl font-bold text-foreground">
            Create New Company
          </h1>
          <p className="mt-2 text-muted-foreground">
            Create a new company and assign an admin account
          </p>
        </div>

        {/* Form */}
        <div className="bg-card rounded-lg shadow p-6">
          {showForm && (
            <CreateCompanyForm
              onSuccess={handleSuccess}
              onCancel={handleCancel}
            />
          )}
        </div>
      </div>
    </div>
  )
}
